import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  AlertTitle,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  DialogActions,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import JoditEditorExample from "../../../helpers/JoditEditorExample";
import CreateModal from "./AddParticipant";
import { CustomizedMenus, StyledTableRow } from "../../../helpers/CustomMenu";
import { participantsInitialState } from "./Participants";
import moment from "moment";
import { AddMenu } from "../Participants/Menu";
import { showError } from "../../../helpers/ShowError";
import { SubmitButton } from "../../buttons";
import SelectEmployee from "../../../helpers/SelectEmployee";
import SmallModal from "../../Modal/SmallModel";
import BootStrapDialog from "../../../helpers/BootStrapDialog";
import BootstrapDialogTitle from "../../../helpers/BootstrapDialogTitle";
import { Add } from "@mui/icons-material";

import { AiFillEdit, AiFillDelete } from 'react-icons/ai';
import { toast } from "react-toastify";
import axios from "axios";
import { successToast } from "helpers/Notification";


export const meetingType = [{ value: 'seniorManager', label: 'Senior Management Meeting' }, { value: 'pmo', label: 'PMO Meeting' }, { value: 'project', label: 'Project meeting' }, { value: 'developer', label: 'Developers meeting' }, { value: 'internal', label: 'All Staff' }]


const CreateMeeting = (props) => {
  const {
    info,
    setInfo,
    loggedUser,
    settings,
    rooms,
    // onSubmit,
    GetEmployees,
    setSelectedEmployees,
    selectedEmployees,
    validationMessage,
    field,
    errorMessage,
    setField,
    onSubmitDraft,
    createRoom,
    setLoading,
    projects,
    resources,
    loading,
    mainBackground
  } = props;

  const [owners, setOwners] = useState([]);
  const [editObject, setEditObject] = useState([]);
  // const [select, setSelect] = useState(false);
  const [selectEmployee, setSelectEmployee] = useState(false);
  const [index, setIndex] = useState();
  const [other, setOther] = useState(false);
  const [participants, setParticipants] = React.useState(
    participantsInitialState
  );
  // const [view, setView] = useState(false);
  // const [user, setUser] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [confirm, setConfirm] = useState(false);
  const [confirmDraft, setConfirmDraft] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [addingRoom, setAddingRoom] = useState(false);
  const [roomName, setRoomName] = useState("");
  const [employee, setEmployee] = useState(null);
  // const [meetingType, setMeetingType] = useState("");
  const [meetingTypes, setMeetingTypes] = useState([]);

  let history = useHistory();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const onSubmit = async (owners, duration) => {
    try {
      const response = await axios.post("/api/meeting/create", {
        ...info,
        duration,
        participants: selectedEmployees,
        owners,
      });
  
  
      // Check if the response is successful
      if (response.status === 200 || response.status === 201) {
        // Fetch the room and update its isBooked status
        if (info?.roomId) {
          await axios.post(`/api/room/update/${info.roomId}`, {
            isBooked: true,
          });
        }

        // Redirect or show success message
        successToast("Meeting scheduled successfully!");
        history.push("/admin/meeting");
      } else {
        successToast("Failed to schedule the meeting.");
      }
    } catch (error) {
      successToast("An error occurred while scheduling the meeting.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetch meeting types from the server
    const fetchMeetingTypes = async () => {
      try {
        const response = await axios.get("/api/meeting/type/list");
        if (response.status === 200) {
          setMeetingTypes(response.data?.data.data);
        }
      } catch (error) {
        console.error("Error fetching meeting types:", error);
      }
    };
    fetchMeetingTypes();
  }, []);


  const handleClose = () => {
    setAnchorEl(null);
  };
  // const userProps = {
  //   type:info?.type,
  //   onSelectUser,
  //   onSelectRole,
  //   selectedUsers,
  //   removeUser,
  //   GetAllChildren,
  //   loggedUser,
  //   title: "Select Participants",
  //   users,
  //   setSelect,
  // };

  useEffect(() => {
  }, [meetingType]);

  const EditValue = (value) => {
    let array = [...owners];
    let index = array.indexOf(editObject);
    owners[index] = value;
    setEditObject([]);
  };

  const getDuration = () => {
    let days = moment(info?.end).diff(moment(info?.start), "days");
    let msg = null;
    if (days < 0) {
      return {
        error: true,
        message: "End date has to be greater than start date",
      };
    } else if (days === 0) {
      let hours = moment(info?.end).diff(moment(info?.start), "hours");

      if (hours <= 0) {
        let minutes = moment(info?.end).diff(moment(info?.start), "minutes");
        msg = msg ?? `${minutes} minutes`;
      }
      msg = msg ?? `${hours} hours`;
    }

    msg = msg ?? `${days} days`;
    return {
      error: false,
      message: `Meeting duration is ${msg}`,
      duration: msg,
    };
  };
  let dur = getDuration();


  const client = projects?.find((item) => item.id === info?.projectId)
  return (
    <div>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb flex items-center">
          <li className="breadcrumb-item pageTitle">
            <Link to="/admin/meeting" className="text-white text-decoration-none">
              Meeting  /
            </Link>
          </li>
          <li className="breadcrumb-item active pageTitle ml-1" aria-current="page">
            Schedule
          </li>
        </ol>
      </nav>
      <div>
        <CreateModal
          initialState={participants}
          employee={employee}
          editObject={editObject}
          EditValue={EditValue}
          toggleModal={setOther}
          open={other}
          setSelectedEmployees={setSelectedEmployees}
          selectedEmployees={selectedEmployees}
        />
     
        {selectEmployee && (
          <SelectEmployee
            selectedEmployees={selectedEmployees}
            confirm={(data) => setSelectedEmployees(data)}
            getEmployees={GetEmployees}
            settings={settings}
            open={selectEmployee}
            onClose={() => setSelectEmployee(false)}
            resources={resources}
          />
        )}
        <BootStrapDialog open={openModal} fullWidth={true} maxWidth={"xs"}>
          <BootstrapDialogTitle
            id={"create-dialog-room"}
            onClose={() => setOpenModal(false)}>
            Create new Room
          </BootstrapDialogTitle>
          <form
            action=""
            onSubmit={async (e) => {
              e.preventDefault();
              setOpenModal(false);
              setAddingRoom(true);
              successToast("Created new room");
              const { data } = await createRoom(roomName ?? "");
              if (data) {
                setInfo({ ...info, roomId: data.id });
                setOpenModal(false);
              }
              setAddingRoom(false);
            }}>
            <DialogContent>
              <TextField
                value={roomName}
                onChange={(e) => setRoomName(e.target.value)}
                placeholder={"Room name"}
                fullWidth={true}
                size={"small"}
                label={"Room name"}
                required={true}
              />
            </DialogContent>
            <DialogActions>
              <Button color={"error"} onClick={() => setOpenModal(false)}>
                Cancel
              </Button>
              <Button
                variant={"contained"}
                type={"submit"}
                style={{ backgroundColor: mainBackground }}>
                Create
              </Button>
            </DialogActions>
          </form>
        </BootStrapDialog>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setConfirm(true);
          }}>
          <Card className="mt-4">
            <CardHeader
              title={"Schedule New Meeting"}
              titleTypographyProps={{ variant: "h6" }}
              action={
                <div>
                  <span className="fs-6 text-red">{errorMessage}</span>
                </div>
              } />
            <CardContent>
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <div className="mb-3 grid grid-cols-2 gap-2">
                    <div>
                      <label className="col-form-label fw-bold text-capitalize">
                        Meeting Name
                        <span className="text-red fs-6">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={info?.name}
                        required={true}
                        onBlur={() => {
                          setField("name");
                        }}
                        onChange={(event) => setInfo({ ...info, name: event.target.value })}
                      />
                      {field === "name" && showError(field, validationMessage)}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="col-form-label fw-bold text-capitalize">
                        Meeting Type
                        <span className="text-red fs-6">*</span>
                      </label>
                      <select
                        value={info?.type}
                        className="form-select text-capitalize px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        required={true}
                        onChange={(e) => setInfo({ ...info, type: e.target.value })}
                      >
                        <option value="">Select...</option>
                        {meetingTypes.map((item) => (
                          <option value={item.name} key={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>


                    <div className="col-md-6 mb-3">
                      <label className="col-form-label fw-bold text-capitalize">
                        Meeting Model
                        <span className="text-red fs-6">*</span>
                      </label>
                      <select
                        value={info?.mode}
                        className="form-select text-capitalize px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        required={true}
                        onChange={(e) => setInfo({ ...info, mode: e.target.value })}
                      >
                        <option value="">Select...</option>
                        {/* virtual */}
                        <option value="Virtual Meeting">Virtual Meeting</option>
                        <option value="Physical Meeting">Physical Meeting</option>
                      </select>
                    </div>

                    {/* Conditional Meeting Link Field */}
                    {(info?.mode === "Virtual Meeting") && (
                      <div className="col-md-6 mb-3">
                        <label className="col-form-label fw-bold text-capitalize">
                          Meeting Link
                          <span className="text-red fs-6">*</span>
                        </label>
                        <input
                          type="url"
                          placeholder="https://..."
                          className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          value={info?.venue || ""}
                          required={info?.mode === "Virtual Meeting"}
                          onBlur={() => {
                            setField("venue");
                          }}
                          onChange={(event) => setInfo({ ...info, venue: event.target.value })}
                        />
                        {field === "venue" && showError(field, validationMessage)}
                      </div>
                    )}

                    <div className="col-md-6 mb-3">
                      <label className="col-form-label fw-bold text-capitalize">
                        Start
                        <span className="text-red fs-6">*</span>
                      </label>
                      <input
                        type="datetime-local"
                        name="start"
                        className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={info?.start}
                        required={true}
                        min={moment().format("YYYY-MM-DDTHH:mm")}
                        onBlur={() => {
                          setField("start");
                        }}
                        onChange={(event) => {
                          setInfo({ ...info, start: event.target.value });
                          setField("start");
                        }}
                      />
                      {field === "start" && showError(field, validationMessage)}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="col-form-label fw-bold text-capitalize">
                        End
                        <span className="text-red fs-6">*</span>
                      </label>
                      <div>
                        <input
                          type="datetime-local"
                          name="end"
                          className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          value={info?.end}
                          required={true}
                          min={moment(info?.start).format("YYYY-MM-DDTHH:mm")}
                          onBlur={() => {
                            setField("end");
                          }}
                          onChange={(event) => {
                            setInfo({ ...info, end: event.target.value });
                          }}
                        />
                      </div>
                      {field === "end" && showError(field, validationMessage)}
                    </div>

                    {info?.start && info?.end && moment(info?.end).isBefore(moment(info?.start)) ? (
                      <div className="col-md-12">
                        <Alert severity="error" variant="outlined">
                          <AlertTitle>Validation Error</AlertTitle>
                          End date/time must be after start date/time.
                        </Alert>
                      </div>
                    ) : info?.start && info?.end && moment(info?.end).diff(moment(info?.start), "hours", true) > 12 ? (
                      <div className="col-md-12">
                        <Alert severity="error" variant="outlined">
                          <AlertTitle>Validation Error</AlertTitle>
                          Meeting duration cannot exceed 12 hours.
                        </Alert>
                      </div>
                    ) : info?.start && info?.end ? (
                      <div className="col-md-12">
                        <Alert severity={dur.error ? "error" : "success"} variant="outlined">
                          <AlertTitle>Start - End duration</AlertTitle>
                          {dur.message}
                        </Alert>
                      </div>
                    ) : null}


                      {info?.mode === "Virtual Meeting" ?  (
                        null):(
                        <div className="col-md-6 mb-3">
                          <div className={"flex justify-between"}>
                            <div className={"flex-grow-1"}>
                              <label className="col-form-label fw-bold text-capitalize">
                                Meeting Room
                                <span className="text-red fs-6">*</span>
                              </label>
                            </div>
                          </div>
                          <select
                            value={info?.roomId}
                            className="form-select px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            onBlur={() => {
                              setField("venue");
                            }}
                            onChange={(e) => setInfo({ ...info, roomId: e.target.value })}>
                            <option selected value={""}>
                              {"Select---"}
                            </option>
                            {rooms?.map((item) => (
                              <option value={item.id}>{item.name}</option>
                            ))}
                          </select>
                          {field === "venue" && showError(field, validationMessage)}
                        </div>
                        )}



                    <div>
                      <label className="col-form-label fw-bold text-capitalize">
                        Reminder
                        <span className="text-red fs-6">*</span>
                      </label>
                      <select
                        value={info?.reminder}
                        id="reminder"
                        className="form-select px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        required={true}
                        onChange={(e) => setInfo({ ...info, reminder: e.target.value })}>
                        <option selected>{"Select..."}</option>
                        {[
                          { name: 15, label: "15 min before" },
                          { name: 30, label: "30 min before" },
                          { name: 60, label: "1 hour before" },
                          { name: 1, label: "1 day before" },
                        ].map((item) => (
                          <option value={item.name}>{item.label}</option>
                        ))}
                      </select>
                    </div>
                    {info?.type === 'project' ?
                      <>
                        <div>
                          <label className="col-form-label fw-bold text-capitalize">
                            Projects
                            {info?.type === 'project' ? <span className="text-red fs-6">*</span> : null}
                          </label>
                          <select
                            value={info?.projectId}
                            className="form-select px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            required={true}
                            onBlur={() => { setField("project"); }}
                            onChange={(e) => setInfo({ ...info, projectId: e.target.value })}>
                            <option selected value={""}>{"Select project"}</option>
                            {projects?.map((item) => (
                              <option value={item.id}>{item.name}</option>
                            ))}
                            {loggedUser?.allowAllProject ? <option value={"all"}>{"All project"}</option> : null}
                          </select>
                        </div>
                        {info?.projectId !== 'all' ?
                          <div>
                            <label className="col-form-label fw-bold text-capitalize">
                              Client
                              {info?.type === 'project' ? <span className="text-red fs-6">*</span> : null}
                            </label>
                            <input
                              type="text"
                              className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                              value={client?.client}
                              disabled
                            />
                          </div>
                          : null}
                      </>
                      : null}
                  </div>
                </div>
              </div>
              <Card className={"mt-3 mb-3"} variant={"outlined"}>
                <CardHeader
                  title={"Agenda"}
                  titleTypographyProps={{ variant: "h6" }} />
                <CardContent>
                  {field === "agenda" && showError(field, validationMessage)}
                  <JoditEditorExample
                    htmlContent={info?.agenda ?? ""}
                    onBlur={(str) => {
                      setInfo({ ...info, agenda: str.target.value });
                      setField("agenda");
                    }}
                  />
                </CardContent>
              </Card>
              <Card variant={"outlined"} className="overflow-auto">
                <CardHeader
                  title={
                    <span className="text-capitalize">{`Participants(s)`}</span>
                  }
                  titleTypographyProps={{ variant: "h6" }}
                  action={
                    <div>
                      {/* <Button onClick={ExportFormat} className={"me-2"}>
                        <i className="fa fa-cloud-download-alt me-1 " /> Export
                        Sample File
                      </Button> */}
                      {/* <Button
                        onClick={() => setUpload(true)}
                        className={"me-2"}>
                        <i className="fa fa-cloud-upload-alt me-1 " /> Upload
                        Excel File
                      </Button> */}

                      <Button onClick={handleClick}
                        variant="contained"
                        size="small"
                        // style={{ backgroundColor: mainBackground }}
                        sx={{
                          backgroundColor: mainBackground ? mainBackground : '#526680',
                          color: 'white',
                          '&:hover': { backgroundColor: mainBackground ? mainBackground : '#526680' }
                        }
                        }>
                        <i className="fa fa-plus fa-md me-1 " /> Add New

                      </Button>
                      <AddMenu
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        setSelectEmployee={setSelectEmployee}
                        setOther={(v) => {
                          setOther(v);
                          setEmployee(null);
                        }}
                      />
                    </div>
                  }></CardHeader>
                <CardContent>
                  <div>
                    <TableContainer>
                      <Table size={"small"}>
                        <TableHead>
                          <TableRow>
                            <TableCell>#</TableCell>
                            {participants?.map((v) => (
                              <TableCell className="text-capitalize">
                                {v.label}
                              </TableCell>
                            ))}
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {owners.map((owner, index) => (
                            <StyledTableRow>
                              <TableCell>#{index + 1}</TableCell>
                              {owner.map((v) => (
                                <TableCell>{v.value}</TableCell>
                              ))}
                              <TableCell>
                                <CustomizedMenus
                                  owner={owners[index]}
                                  setIndex={setIndex}
                                  index={index}
                                  setEditObject={setEditObject}
                                  onDelete={() => {
                                    setOwners([
                                      ...owners.slice(0, index),
                                      ...owners.slice(index + 1),
                                    ]);
                                  }}
                                  setModelOpen={setOther}
                                />
                              </TableCell>
                            </StyledTableRow>
                          ))}
                          {selectedEmployees?.map(
                            (user, index) => (
                              <StyledTableRow key={index}>
                                <TableCell>#{index + 1}</TableCell>
                                <TableCell>{user?.names}</TableCell>
                                <TableCell>{user?.category}</TableCell>
                                <TableCell>{user?.phone}</TableCell>
                                <TableCell>{user?.email}</TableCell>
                                <TableCell >
                                  <div className="grid grid-cols-2 gap-2">
                                    <AiFillEdit
                                      onClick={() => {
                                        setEmployee({ ...user });
                                        setOther(true);
                                      }}
                                      color="blue"
                                      size={22}
                                      className="cursor-pointer" />
                                    <AiFillDelete
                                      onClick={() => {
                                        const newEmp = selectedEmployees.filter((emp) => (emp.email !== selectedEmployees[index].email));
                                        setSelectedEmployees(newEmp);
                                      }}
                                      color="red"
                                      size={22}
                                      className="cursor-pointer" />
                                  </div>
                                </TableCell>
                              </StyledTableRow>
                            )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </CardContent>
              </Card>
            </CardContent>
            <CardActions className={"float-end"}>
              <Button
                color={"error"}
                size="small"
                variant="contained"
                onClick={() => history.goBack()}>
                Cancel
              </Button>
              {loading ? (
                <CircularProgress />
              ) : (
                <>
                  <SubmitButton
                    name="Add"
                    title={"Do you want to schedule this meeting?"}
                    handleAction={() => {
                      setLoading(true);
                   
                      return onSubmit(owners, dur.duration);
                    }}
                    confirm={confirm}
                    setConfirm={setConfirm}
                  />
                </>
              )}
            </CardActions>
          </Card>
        </form>
        <SmallModal
          select={confirmDraft}
          setSelect={setConfirmDraft}
          confirm={() => {
            onSubmitDraft(owners, dur.duration);
          }}>
          <i className="fa fa-check-circle fa-4x text-success me-2" />
          <span>{"Are you sure you want to save draft ?"}</span>
        </SmallModal>
      </div>
    </div>
  );
};
export default CreateMeeting;
